// extracted by mini-css-extract-plugin
export default {"hyperQuill":"hyperPersonalizedModal_hyperQuill__q3VmC","candidateListContainer":"hyperPersonalizedModal_candidateListContainer__vCMiT"};